import { NominationFormErrorJSON } from '../models/nomination-form';

export const formNominationErrors: NominationFormErrorJSON = {
    firmsCode: [
        {
            code: 'required',
            message: '1F Port Destination Firms Code is required',
        },
        {
            code: 'minlength',
            message: '1F Port Destination Firms Code be of 4 characters',
        },
        {
            code: 'maxlength',
            message: '1F Port Destination Firms Code be of 4 characters',
        },
        {
            code: 'blockFirmscodeExist',
            message: 'Invalid Firms code: check your 1F port destination firms code and try again',
        },
    ],
    awb: [
        {
            code: 'required',
            message: 'This field is required',
        },
    ],
    companyName: [
        {
            code: 'required',
            message: 'Company name is required',
        },
    ],
    email: [
        {
            code: 'multipleEmails',
            message: 'Invalid email(s)',
        },
        {
            code: 'required',
            message: 'Email is required',
        },
    ],
};
